import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'
import { getNewProducts } from 'store/product/actions'

export const getWishlist = createAsyncThunk('get/wishlist', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/products/wishlist`)

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const addWishlist = createAsyncThunk('add/wishlist', async (id: number, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await axiosInstance.post(`/v1/products/wishlist/${id}`)

    dispatch(getWishlist())

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const deleteWishlist = createAsyncThunk('delete/wishlist', async (id: number, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await axiosInstance.delete(`/v1/products/wishlist/${id}`)

    dispatch(getWishlist())
    dispatch(getNewProducts(process.env.REACT_APP_CATEGORY_ID))

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getBasket = createAsyncThunk('get/basket', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/shop/v1/cart`)

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const addBasket = createAsyncThunk<{ data: any }, { body: any; rejectValue: any }>(
  'add/basket',
  async ({ body }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/shop/v1/cart`, body)

      return data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const deleteBasket = createAsyncThunk('delete/basket', async (id: number, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await axiosInstance.delete(`/v3/cart-option/${id}`)

    dispatch(getBasket())

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const updateBasket = createAsyncThunk(
  'update/basket',
  async ({ id, body }: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axiosInstance.put(`/v3/cart-option/${id}`, body)

      dispatch(getBasket())

      return data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createOrder = createAsyncThunk('create/order', async (body: any, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await axiosInstance.post(`/shop/v1/order`, body)

    dispatch(getBasket())

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getInformations = createAsyncThunk('get/informations', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/store/${process.env.REACT_APP_STORE_ID}/informations`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
